import { render, staticRenderFns } from "./ComponentsHeader.vue?vue&type=template&id=5f7bdc2b&scoped=true&"
import script from "./ComponentsHeader.vue?vue&type=script&lang=js&"
export * from "./ComponentsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ComponentsHeader.vue?vue&type=style&index=0&id=5f7bdc2b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7bdc2b",
  null
  
)

export default component.exports